import React, { useEffect, useState } from "react";
import * as API from "../api";

export default function FiscalYears() {
  const [years, setYears] = useState([]);
  const [newYear, setNewYear] = useState("");

  useEffect(() => {
    fetchFiscalYears();
  }, []);

  async function fetchFiscalYears() {
    const data = await API.getFiscalYears();
    setYears(data);
  }

  async function handleAddYear() {
    if (!newYear) return alert("سال را وارد کنید");
    await API.addFiscalYear({ year: newYear });
    setNewYear("");
    fetchFiscalYears();
  }

  async function handleToggleYear(id) {
  await fetch(`/api/fiscal-years/${id}/toggle`, {
    method: "PUT",
  });
  fetchFiscalYears();
}

  async function handleDeleteYear(id) {
    if (window.confirm("آیا از حذف این سال مطمئن هستید؟")) {
      await API.deleteFiscalYear(id);
      fetchFiscalYears();
    }
  }

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">مدیریت سال‌های مالی</h2>

      <div className="flex gap-2 mb-4">
        <input
          type="text"
          value={newYear}
          onChange={(e) => setNewYear(e.target.value)}
          placeholder="سال جدید (مثلاً 1403)"
          className="border p-2 rounded w-64"
        />
        <button
          onClick={handleAddYear}
          className="bg-blue-500 text-white px-4 py-2 rounded"
        >
          افزودن
        </button>
      </div>

      <table className="w-full border">
        <thead>
          <tr className="bg-gray-200 text-right">
            <th className="p-2">سال</th>
            <th className="p-2">وضعیت</th>
            <th className="p-2">عملیات</th>
          </tr>
        </thead>
        <tbody>
          {years.map((y) => (
            <tr key={y.id} className="border-t">
              <td className="p-2">{y.year}</td>
              <td className="p-2">
                {y.is_closed ? "بسته" : "باز"}
                <button
                  onClick={() => handleToggleYear(y.id)}
                  className="ml-2 bg-yellow-500 text-white px-3 py-1 rounded"
                >
                  تغییر
                </button>
              </td>
              <td className="p-2">
                <button
                  onClick={() => handleDeleteYear(y.id)}
                  className="bg-red-500 text-white px-3 py-1 rounded"
                >
                  حذف
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
